// @flow
import * as React from 'react';
import Select, {SelectOption} from 'sail/Select';
import {countryList} from './AcceptASEPADebitPaymentScenarios';

type Props = {
  onChange: Function,
};

const SEPANumberDropdown = (props: Props) => {
  return (
    <Select onChange={(e) => props.onChange(e)}>
      {Object.keys(countryList).map((country, index) => (
        <SelectOption key={index} value={country} label={country} />
      ))}
    </Select>
  );
};

export default SEPANumberDropdown;
